
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/saa/retire/survey",
      function () {
        return require("private-next-pages/saa/retire/survey/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/saa/retire/survey"])
      });
    }
  